export const ADD_MONITOR_MODAL_ID = 'add-monitor-modal';
